import * as actions from './actionTypes';

const initialState = {
  shouldShowModal: false,
};

export default function modalReducer(state = initialState, action = {}) {
  switch (action.type) {
    case actions.SHOW_MODAL: {
      return {
        ...state,
        shouldShowModal: true,
      };
    }

    case actions.HIDE_MODAL: {
      return {
        ...state,
        shouldShowModal: false,
      };
    }

    default: {
      return state;
    }
  }
}
